import type { RouteObject } from 'react-router';

import { registerEditorialBlocks } from '../_shared/blocks';
import { EditorialDetailPage } from './EditorialDetail';

/**
 * The post as the reader will see it, and the reviewer's decision beside it.
 *
 * The block registry is populated here as well as on the list route: a reviewer
 * may arrive on this URL directly from a notification, and a renderer that has
 * not been registered draws an empty article rather than a post.
 */
registerEditorialBlocks();

export const editorialDetailRoute: RouteObject = {
  path: 'editorial/:postId',
  element: <EditorialDetailPage />,
};
